import { motion } from "framer-motion";

const testimonials = [
  {
    quote:
      "It's like hiring a full ads team overnight. The AI drafts everything, I approve on my phone, and our CPL dropped 28% in the first month.",
    name: "Ananya Sharma",
    role: "Founder, D2C skincare brand",
    img: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?crop=entropy&cs=srgb&fm=jpg&q=85&w=200",
  },
  {
    quote:
      "The approval queue is the killer feature. Nothing goes live without my click, but I stopped spending evenings inside Ads Manager.",
    name: "Grace Lin",
    role: "Marketing lead, SaaS startup",
    img: "https://images.unsplash.com/photo-1484863137850-59afcfe05386?crop=entropy&cs=srgb&fm=jpg&q=85&w=200",
  },
  {
    quote:
      "Lead scoring alone paid for the subscription. Our sales team calls Hot leads first and close rates went up immediately.",
    name: "Rahul Mehta",
    role: "Agency owner",
    img: "https://images.unsplash.com/photo-1560250097-0b93528c311a?crop=entropy&cs=srgb&fm=jpg&q=85&w=200",
  },
];

const fadeUp = {
  hidden: { opacity: 0, y: 32 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1], delay: i * 0.12 },
  }),
};

export default function Testimonials() {
  return (
    <section className="py-24 md:py-32 bg-white border-y border-neutral-200" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <motion.div custom={0} variants={fadeUp} initial="hidden" whileInView="visible" viewport={{ once: true, margin: "-80px" }}>
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-neutral-500">04 — Loved by advertisers</p>
          <h2 className="font-heading font-medium tracking-tight text-3xl md:text-4xl text-neutral-900 mt-4 max-w-2xl">
            Teams run leaner. Ads run smarter.
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-6 md:gap-8 mt-14">
          {testimonials.map((t, i) => (
            <motion.figure
              key={t.name}
              custom={i}
              variants={fadeUp}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, margin: "-40px" }}
              className="bg-[#FDFCFB] border border-neutral-200 rounded-2xl p-8 flex flex-col justify-between"
              data-testid={`testimonial-card-${i}`}
            >
              <blockquote className="text-neutral-700 leading-relaxed text-sm md:text-base">
                “{t.quote}”
              </blockquote>
              <figcaption className="flex items-center gap-3 mt-8">
                <img src={t.img} alt={t.name} className="w-10 h-10 rounded-full object-cover" />
                <div>
                  <p className="text-sm font-medium text-neutral-900">{t.name}</p>
                  <p className="text-xs text-neutral-500">{t.role}</p>
                </div>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
